import moment from "moment";

export function monthFilter() {
  function filter(monthNumber){
    if(!monthNumber)
      return '';

    const language = localStorage.getItem('roedl-language');
    return moment().locale(language).month(Number(monthNumber)-1).format('MMMM');
  }
  filter.$stateful = true;
  return filter;
}